import React from 'react';
import PropTypes from 'prop-types';

import BonusPresenter from '../../../../../../../../../presenters/Membership/BonusPresenter';

const BonusCell = (props) => {
  const { bonus, onDeleteDialogOpen } = props;

  return (
    <tr>
      <td className="cell">{BonusPresenter.amountReadable(bonus)}</td>
      <td className="cell">{BonusPresenter.state(bonus)}</td>
      <td className="cell">{BonusPresenter.typeReadable(bonus)}</td>
      <td className="cell">{BonusPresenter.createdAtReadable(bonus)}</td>
      <td className="button-cell">
        <div
          id="deleteBonus"
          className="action-button"
          onClick={onDeleteDialogOpen(bonus)}
        >
          Delete
        </div>
      </td>
    </tr>
  );
};

export default BonusCell;

BonusCell.propTypes = {
  bonus: BonusPresenter.shape().isRequired,
  onDeleteDialogOpen: PropTypes.func.isRequired,
};
